<script setup lang="ts">
  defineOptions({ name: 'EmCardSubtitle' })
</script>

<template>
  <div class="emerald-card__subtitle">
    <slot />
  </div>
</template>
